/* eslint-disable prefer-spread */
import { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";

import axios from "axios";

import { GrantsAndIncentivesContext, ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import getUniqueListBy from "common/lodash/getUniqueListBy";

import ButtonNew from "components/atoms/ButtonNew";
import { AiFillCaretDown } from "components/atoms/Icon/ai/AiFillCaretDown";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FiFilter } from "components/atoms/Icon/fi/FiFilter";
import { IoChevronDown } from "components/atoms/Icon/io5/IoChevronDown";
import Image from "components/atoms/Img";
import Popup from "components/atoms/Popup";
import Recaptcha from "components/atoms/Recaptcha";
import Toast from "components/atoms/Toast";

import Pagination from "./Pagination";

import styles from "../Index.module.scss";
import styleStep from "./Index.module.scss";

const customStyles = {
  container: (provided) => ({
    ...provided,
    minWidth: 185,
  }),
  control: (provided) => ({
    ...provided,
    color: "#333",
    borderRadius: 10,
    padding: "12px 24px",
    lineHeight: "26px",
    borderWidth: "0.5px",
    backgroundColor: "#F5F5F5",
    boxShadow: "none",
    fontWeight: "500",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 10,
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    color: state.isSelected ? "#007eff" : "#333",
    background: state.isSelected || state.isFocused ? "#F1FBFF" : "",
    fontWeight: state.isSelected ? "600" : "normal",
  }),
  placeholder: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    color: "#333",
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    lineHeight: "26px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "0px",
  }),
};

function Step3Layout() {
  const { setStep, userData, dataStep1, dataStep2, reset } = useContext(
    GrantsAndIncentivesContext
  );
  const recaptchaRef = useRef();
  const { openAlert } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);
  const [holdGrants, setHoldGrants] = useState([]);
  const [grants, setGrants] = useState([]);
  const [types, setTypes] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState(null);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [grantsPerPage] = useState(6);
  const [selectedGrants, setSelectedGrants] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Get current grants
  const indexOfLastPost = currentPage * grantsPerPage;
  const indexOfFirstPost = indexOfLastPost - grantsPerPage;
  const currentGrants = grants?.slice(indexOfFirstPost, indexOfLastPost);
  const [howManyPages, setHowManyPages] = useState(0);

  const {
    needs_based,
    business_stage,
    industry,
    years_operation,
    business_size,
    number_employees,
    local_shareholding,
    country_id,
  } = {
    ...dataStep1,
    ...dataStep2,
  };
  const [params] = useState({
    needs_based_id: needs_based,
    industry_id: industry,
    business_stage_id: business_stage,
    years_operation_id: years_operation,
    local_shareholding_id: local_shareholding,
    ...(business_size && { business_size_id: business_size }),
    ...(number_employees && { number_employees_id: number_employees }),
    ...(country_id === 191 && { country_id }),
  });

  // Fetch grants
  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);

      const api_link = `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/tools/grant_scheme`;

      if (
        needs_based &&
        industry &&
        business_stage &&
        years_operation &&
        local_shareholding &&
        (business_size || number_employees)
      ) {
        const res = await axios.get(api_link, {
          params,
        });

        const custom_res_data = getUniqueListBy(res.data.data.rows, "id");

        const getTypes = getUniqueListBy(
          [].concat
            .apply(
              [],
              custom_res_data.map((item) => item.type)
            )
            .map((item) => ({
              label: item,
              value: item,
            })),
          "label"
        );
        const getAgencies = getUniqueListBy(
          [].concat
            .apply(
              [],
              custom_res_data.map((item) => item.agency)
            )
            .map((item) => ({
              label: item,
              value: item,
            })),
          "label"
        );

        setHowManyPages(Math.ceil(custom_res_data.length / grantsPerPage));
        setTimeout(() => {
          setGrants(custom_res_data);
          setTypes(getTypes);
          setAgencies(getAgencies);
          setHoldGrants(custom_res_data);
          setLoading(false);
        }, 500);
      } else {
        setHowManyPages(0);
        setGrants([]);
        setHoldGrants([]);
        setLoading(false);
      }
    };

    fetchPosts();
  }, [dataStep1, dataStep2]);
  useEffect(() => {
    if (selectedTypes && selectedAgency) {
      setGrants(
        holdGrants.filter(
          (item) =>
            item.type.some(
              (typeItem) => typeItem.localeCompare(selectedTypes.label) === 0
            ) &&
            item.agency?.some(
              (agencyItem) =>
                agencyItem.localeCompare(selectedAgency.label) === 0
            )
        )
      );
    } else if (selectedTypes || selectedAgency) {
      if (selectedTypes) {
        setGrants(
          holdGrants.filter((item) =>
            item.type.some(
              (typeItem) => typeItem.localeCompare(selectedTypes.label) === 0
            )
          )
        );
      }
      if (selectedAgency) {
        setGrants(
          holdGrants.filter((item) =>
            item.agency?.some(
              (agencyItem) =>
                agencyItem.localeCompare(selectedAgency.label) === 0
            )
          )
        );
      }
    } else {
      setGrants(holdGrants);
    }
    setSelectedGrants([]);
    setCurrentPage(1);
  }, [selectedTypes, selectedAgency]);

  useEffect(() => {
    const count = Math.ceil(grants.length / grantsPerPage);

    setHowManyPages(count > 0 ? count : 1);
  }, [grants]);

  const onSendData = async () => {
    const token = await recaptchaRef.current.executeAsync();

    if (token && selectedGrants.length > 0) {
      const GAUserID = getGAUserID();
      let dataSend = {};

      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataSend.list_grant_scheme_id = holdGrants.map((item) => item.id);
      dataSend.email = userData.email;
      dataSend.list_grant_scheme_checked_id = selectedGrants.map(
        (item) => item.id
      ); // List client checkbox
      dataSend.company_name = dataStep2.company_name;
      dataSend = { ...dataSend, ...params };
      delete dataSend.years_operation_id;

      await axios
        .post(
          `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/tools/grant_scheme/mail_send_me_program_details`,
          dataSend,
          {
            headers: {
              "captcha-response": token,
            },
          }
        )
        .then((res) => {
          if (res.data.state) {
            // Trigger("contact_form", data, "Contact Form - Singapore Grants");
            openAlert(3000, "success");
          } else {
            // Temp position to test local storage
            console.log("error");
          }
        })
        .catch((error) => {
          console.log(error);
          openAlert(3000, "error");
        });
    } else {
      openAlert(3000, "error");
    }
    setIsSubmitting(false);
  };

  const renderResult = () => {
    if (loading && grants.length === 0) {
      return (
        <h1
          className="flex items-center justify-center"
          style={{ height: "1000px" }}
        >
          <BiLoaderAlt className="absolute mr-2 animate-spin" size={24} />
        </h1>
      );
    }
    if (currentGrants.length > 0) {
      if (howManyPages > 1)
        return (
          <>
            <ListGrant
              data={currentGrants}
              selectedGrants={selectedGrants}
              setSelectedGrants={setSelectedGrants}
              selectedTypes={selectedTypes}
              selectedAgency={selectedAgency}
            />
            <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
          </>
        );

      return (
        <ListGrant
          data={currentGrants}
          selectedGrants={selectedGrants}
          setSelectedGrants={setSelectedGrants}
          selectedTypes={selectedTypes}
          selectedAgency={selectedAgency}
        />
      );
    }

    return (
      <div className="mb-10 bg-bbc-yellow-300 bg-opacity-30 p-4 text-center">
        No Result
      </div>
    );
  };

  return (
    <>
      <div className={` ${styles.step3}`}>
        <div className={"mb-10 flex "}>
          {holdGrants?.length > 0 && (
            <>
              <div className="mr-4 flex items-center  text-bbc-neutral-700 lg:mr-10">
                <FiFilter
                  className="m-1 inline-block"
                  style={{ minWidth: "20px", minHeight: "20px" }}
                />{" "}
                <span className="whitespace-nowrap">Filter by</span>
              </div>
              <div className="flex flex-wrap">
                <Select
                  isClearable={true}
                  isDisabled={holdGrants.length === 0}
                  options={types}
                  isSearchable={true}
                  inputMode="search"
                  placeholder={"Type"}
                  styles={customStyles}
                  className="mb-2 w-full md:my-1 md:mr-6 md:mb-0 md:w-fit"
                  components={{
                    DropdownIndicator: () => (
                      <IoChevronDown className="cursor-pointer" size={20} />
                    ),
                  }}
                  onChange={(value) => {
                    setSelectedTypes(value);
                  }}
                />
                <Select
                  isClearable={true}
                  isDisabled={holdGrants.length === 0}
                  options={agencies}
                  isSearchable={true}
                  inputMode="search"
                  placeholder={"Agency"}
                  styles={customStyles}
                  className="w-full md:my-1 md:w-fit"
                  components={{
                    DropdownIndicator: () => (
                      <IoChevronDown className="cursor-pointer" size={20} />
                    ),
                  }}
                  onChange={(value) => {
                    setSelectedAgency(value);
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div className="my-10 ">{renderResult()}</div>
        {holdGrants?.length > 0 && (
          <div className="rounded-xl border border-dashed border-bbc-brand-200 bg-bbc-brand-100 p-6">
            <Image
              src="/assets/icons/note.svg"
              width={139}
              height={58}
              alt="note"
            />
            <p className="text-bbc-secondary-400">
              You can select up to 3 supporting programs to be sent to your
              email.
            </p>
          </div>
        )}
        {/* <Pagination
          grantsPerPage={grantsPerPage}
          totalGrants={grants.length}
          paginate={paginate}
          currentPage={currentPage}
        /> */}
      </div>
      <div className="text-center">
        {holdGrants?.length > 0 && (
          <>
            <ButtonNew
              disabled={
                holdGrants.length === 0 ||
                selectedGrants.length === 0 ||
                isSubmitting
              }
              btnPadding="px-10 py-2"
              othersClass={"mb-10 lg:mb-6 relative"}
              onClick={async () => {
                setIsSubmitting(true);
                await onSendData();
              }}
            >
              {isSubmitting && (
                <BiLoaderAlt
                  className="absolute left-2 animate-spin"
                  size={24}
                />
              )}
              Send me all program details
            </ButtonNew>
            <div className="invisible h-0 w-0">
              <Recaptcha ref={recaptchaRef} />
            </div>
          </>
        )}
        <div>
          {holdGrants?.length > 0 && <span className="font-medium">Or </span>}
          <ButtonNew
            variant={"ghost"}
            btnPadding={"px-0 py-0"}
            onClick={async () => {
              // eslint-disable-next-line no-undef
              await Tawk_API.toggle();
            }}
          >
            Chat with our consultant
          </ButtonNew>
        </div>
      </div>
      <div className="mt-6 flex justify-between">
        <ButtonNew
          variant={"ghost"}
          btnPadding={"px-0 py-0"}
          onClick={() => {
            setStep((prev) => prev - 1);
          }}
          btnColor={"text-bbc-neutral-600 hover:text-bbc-neutral-700"}
        >
          Back
        </ButtonNew>
        <ButtonNew
          variant={"ghost"}
          btnPadding={"px-0 py-0"}
          onClick={() => {
            openAlert(false, "confirm", {
              title: "Are you sure?",
              onClick: () => {
                reset();
              },
            });
          }}
        >
          Retake Assessment
        </ButtonNew>
      </div>
    </>
  );
}

export default function Step3({ data }) {
  return (
    <Toast>
      <Step3Layout data={data} />
    </Toast>
  );
}

const ListGrant = ({
  data,
  selectedGrants,
  setSelectedGrants,
  selectedAgency,
}) => {
  /* Handle Event */
  const isTypeInSelectedGrants = () => {
    // If (selectedTypes || selectedAgency) {
    //   Return false;
    // }
    // Return selectedGrants.findIndex((item) => item.type === grant.type) >= 0;
    return false;
  };
  const isSelectedGrant = (grant) => {
    return selectedGrants.findIndex((item) => item.name === grant.name) >= 0;
  };
  const handleOnLickGrants = (grant) => {
    const isSelected = isSelectedGrant(grant);
    const tempSelected = [...selectedGrants];

    if (isSelected) {
      setSelectedGrants(
        tempSelected.filter((item) => item.name !== grant.name)
      );
    } else {
      if (selectedGrants.length < 3) {
        setSelectedGrants([...tempSelected, grant]);
      }
    }
  };
  /* Define component local */
  const CardGrant = ({ data }) => {
    return (
      <>
        <div className="flex w-full justify-between bg-bbc-brand-700 p-6">
          <div className="flex">
            <input
              disabled={
                (selectedGrants.length >= 3 || isTypeInSelectedGrants(data)) &&
                !isSelectedGrant(data)
              }
              type="checkbox"
              className={` bbc-checkbox mr-2 mt-1 h-6 w-6 rounded-md ${styleStep.checkbox} `}
              checked={isSelectedGrant(data)}
              onChange={() => {
                handleOnLickGrants(data);
              }}
            />
            <div className="text-white ">
              {data.agency.length > 1 ? (
                <>
                  <ul className=" pl-4">
                    {data.agency.map((item, index) => (
                      <li key={index} className="list-disc">
                        {item}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <span>{data.agency[0]}</span>
              )}
            </div>
          </div>
          <span className="ml-4 text-sm font-medium leading-6 text-bbc-yellow-500">
            {data.type}
          </span>
        </div>
        <div className={"relative flex h-full items-start p-6 "}>
          <div className="flex flex-col">
            <p className="mb-4 font-medium text-bbc-brand-700">{data.name}</p>
            <p className="whitespace-pre-line text-bbc-gray">
              {data.description}
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="mb-10 grid-flow-row grid-cols-2 gap-x-7 gap-y-8 md:grid">
        {data.map((item, index) => {
          let agency_show = item.agency[0];

          if (selectedAgency) {
            agency_show = selectedAgency.label;
          }

          return (
            <div
              key={index}
              style={{ maxWidth: "500px" }}
              className={`mx-auto mb-10 flex flex-col overflow-hidden rounded-lg border border-bbc-neutral-600 md:mb-0 ${
                isSelectedGrant(item) ? "bg-yellow-50" : "bg-transparent"
              }`}
            >
              <div
                className="flex w-full cursor-pointer items-center justify-between bg-bbc-brand-700 px-6 py-2"
                onClick={() => {
                  handleOnLickGrants(item);
                }}
                style={{ minHeight: "76px" }}
              >
                <div className="flex items-start">
                  <input
                    disabled={
                      (selectedGrants.length >= 3 ||
                        isTypeInSelectedGrants(item)) &&
                      !isSelectedGrant(item)
                    }
                    type="checkbox"
                    className={` bbc-checkbox mr-2 mt-0.5 h-6 w-6 rounded-md ${styleStep.checkbox} `}
                    checked={isSelectedGrant(item)}
                    onChange={() => {
                      handleOnLickGrants(item);
                    }}
                  />

                  <div className=" text-white ">
                    <div className="inline-block line-clamp-2">
                      {agency_show}{" "}
                      {item.agency.length > 1 && (
                        <>
                          & <span>{item.agency.length - 1} Others Agency </span>{" "}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <span className="ml-4 text-sm font-medium leading-6 text-bbc-yellow-500 ">
                  {item.type}
                </span>
              </div>
              <div className={"relative flex h-full items-start p-6"}>
                <div className="flex h-full flex-col justify-between">
                  <div className="flex-1">
                    <p className="mb-4 font-medium text-bbc-brand-700 line-clamp-3">
                      {item.name}
                    </p>
                    <p className="whitespace-pre-line text-bbc-gray  line-clamp-3">
                      {item.description}
                    </p>
                  </div>
                  <Popup
                    components={
                      <div
                        className={
                          "m-auto overflow-hidden rounded-lg bg-white lg:max-w-3xl"
                        }
                      >
                        <CardGrant data={item} />
                      </div>
                    }
                  >
                    {(item.agency.length > 1 ||
                      item.description.length > 150) && (
                      <div
                        className={
                          "mt-3 text-right text-bbc-brand-600  hover:underline "
                        }
                      >
                        See more <AiFillCaretDown className="inline-block" />
                      </div>
                    )}
                  </Popup>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
